var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmployerMonthlyReport',_vm._b({},'EmployerMonthlyReport',{
    employerId: _vm.employerId,
    selectableBillingPeriods: _vm.selectableBillingPeriods,
    periodsLoaded: _vm.periodsLoaded,
    loadBillingPeriodsByEmployer: _vm.loadBillingPeriodsByEmployer,
    resetBillingPeriodsState: _vm.resetBillingPeriodsState,
    downloadReportForEmployer: _vm.downloadReportForEmployer,
    setPeriod: _vm.setPeriod
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }